import { action } from 'easy-peasy';
import { IActionSetUpdatedBloodPressureReading } from '../types';

const setUpdatedBloodPressureReading: IActionSetUpdatedBloodPressureReading = action(
  (state, payload) => {
    state.triageRequests.requests = state.triageRequests.requests.map(request => {
      if (request.latestReadings.bloodPressure?.id === payload.id) {
        request.latestReadings.bloodPressure = payload;
      }

      return request;
    });
  },
);

export default setUpdatedBloodPressureReading;
